import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import UsersViewReactView from './UsersViewReactView';
import { getChannelNameFromSource, getName } from '../UserUtils';
import { getFormatDateTime } from 'data/date';
import { UserFeatures } from '../UserFeatures';
import * as profileFallback from 'assets/img/UserNone.svg';
import './UsersView.scss';
import UsersViewReactTranslations from './UsersViewReactTranslations';
const userDetailStateName = 'auth.application.detail.users.user';
const UsersViewReact = ({ users, UsersService, UsersSegmentService, TranslateService, $state }) => {
    const [initialized, setInitialized] = useState(false);
    const [isShowingContactsLastInteraction, setIsShowingContactsLastInteraction] = useState(false);
    const _truncateString = (value, maxLength) => {
        if (!value)
            return;
        return value.slice(0, maxLength);
    };
    const _getDecodedUserIdentity = (identity) => {
        return UsersService.getDecodedUserIdentity(identity);
    };
    const _trackContactClickedOnNewTabIcon = () => {
        UsersSegmentService.trackUserClicked({ 'isNewTab': true });
    };
    const _trackContactClickedOnCard = () => {
        UsersSegmentService.trackUserClicked({ 'isNewTab': false });
    };
    const _checkFeatures = async () => {
        setIsShowingContactsLastInteraction(await UserFeatures.isShowingContactsLastInteraction());
    };
    const loadTranslations = () => {
        return new UsersViewReactTranslations(TranslateService.instantTranslate('modules.application.detail.users.name'), TranslateService.instantTranslate('modules.application.detail.users.channel'), TranslateService.instantTranslate('modules.application.detail.users.test'), TranslateService.instantTranslate('modules.application.detail.users.lastInteraction'), TranslateService.instantTranslate('modules.application.detail.users.openInNewTab'));
    };
    const goToUserDetails = (identity) => {
        if (!identity) {
            return;
        }
        const id = UsersService.getDecodedUserIdentity(identity);
        $state.go(userDetailStateName, {
            id,
            userIdentity: undefined,
        });
        _trackContactClickedOnCard();
    };
    const isImageValid = (user) => {
        if (!user || !user.photoUri) {
            return false;
        }
        return true;
    };
    const getUserName = (user) => {
        return _truncateString(getName(user), 25);
    };
    const getFormatedLastInteraction = (user) => {
        return getFormatDateTime(user.lastMessageDate, TranslateService.getCurrentLanguage());
    };
    const getChannelNameFromUserSource = (user) => {
        return _truncateString(getChannelNameFromSource(user.source), 25);
    };
    const openInNewTab = (identity, event) => {
        if (!identity)
            return;
        const id = _getDecodedUserIdentity(identity);
        const url = $state.href(userDetailStateName, { id });
        window.open(url, '_blank');
        _trackContactClickedOnNewTabIcon();
        event.stopPropagation();
    };
    useEffect(() => {
        const initialize = async () => {
            await _checkFeatures();
            setInitialized(true);
        };
        if (!initialized) {
            initialize();
        }
    }, [users]);
    return (_jsx(UsersViewReactView, { users: users, isShowingContactsLastInteraction: isShowingContactsLastInteraction, profileFallback: profileFallback, translations: loadTranslations(), goToUserDetails: goToUserDetails, isImageValid: isImageValid, getName: getUserName, getFormatedLastInteraction: getFormatedLastInteraction, getChannelNameFromSource: getChannelNameFromUserSource, openInNewTab: openInNewTab }));
};
export default UsersViewReact;
